import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/images/workloop-logo.png`;

const LogoImage = ({ className, svgClassName }) => (
  <>
    <img
      src={LOGO_SRC}
      alt="WorkLoop Logo"
      className={className}
      onError={(e) => {
        e.target.style.display = 'none';
        const svg = e.target.nextElementSibling;
        if (svg) {
          svg.classList.remove('hidden');
        }
      }}
    />
    <svg className={`${svgClassName} hidden`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
    </svg>
  </>
);

export const AuthBrandingPanel = () => (
  <div className="hidden lg:flex lg:w-1/2 lg:h-screen lg:shrink-0 bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 flex-col items-center justify-center p-12 text-white relative overflow-hidden">
    <div className="absolute inset-0 opacity-10">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px',
        }}
      />
    </div>

    <div className="relative z-10 flex flex-col items-center justify-center max-w-md pb-14">
      <div className="mb-8">
        <div className="flex items-center justify-center mb-6">
          <div className="w-32 h-32 bg-white rounded-2xl flex items-center justify-center shadow-2xl p-4">
            <LogoImage className="w-full h-full object-contain" svgClassName="w-12 h-12 text-primary-600" />
          </div>
        </div>
        <h1 className="text-5xl font-bold text-center mb-2 tracking-tight">WorkLoop</h1>
        <p className="text-xl text-primary-100 text-center font-light">Seamless Team Communication</p>
      </div>

      <div className="mt-12 space-y-6 w-full">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0 w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-1">Real-time Messaging</h3>
            <p className="text-primary-100 text-sm">Instant communication with your team</p>
          </div>
        </div>
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0 w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-1">Team Collaboration</h3>
            <p className="text-primary-100 text-sm">Work together efficiently and effectively</p>
          </div>
        </div>
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0 w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-1">Secure & Private</h3>
            <p className="text-primary-100 text-sm">Your conversations are protected</p>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white border-opacity-20 w-full text-center">
        <p className="text-sm text-primary-200 font-medium">
          Powered by <span className="font-bold text-white">TechElliptica</span>
        </p>
      </div>
    </div>

    <div className="absolute bottom-6 left-0 right-0 z-10 px-6">
      <p className="text-sm text-primary-200 flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
        <Link to="/privacy" className="font-medium text-white/90 hover:text-white transition-colors">
          Privacy Policy
        </Link>
        <span className="text-white/50" aria-hidden>·</span>
        <Link to="/terms" className="font-medium text-white/90 hover:text-white transition-colors">
          Terms
        </Link>
        <span className="text-white/50" aria-hidden>·</span>
        <Link to="/support" className="font-medium text-white/90 hover:text-white transition-colors">
          Support
        </Link>
      </p>
    </div>
  </div>
);

export const AuthMobileHeader = () => (
  <div className="lg:hidden mb-8 text-center">
    <div className="inline-flex items-center justify-center mb-4">
      <div className="w-20 h-20 bg-white rounded-xl flex items-center justify-center shadow-lg p-3">
        <LogoImage className="w-full h-full object-contain" svgClassName="w-10 h-10 text-primary-600" />
      </div>
    </div>
    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-1">WorkLoop</h1>
    <p className="text-sm text-gray-500 dark:text-gray-400">Powered by TechElliptica</p>
  </div>
);
